module.exports = __webpack_public_path__ + "img/placeholder.36501fcc.jpg";